import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { AuthCodeResult, AuthResult } from '@lentau/auth/shared';
import { checkEmptyFields } from '../utils';

export function authCodeSendHandler(data: AuthCodeResult): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.sent,
        errorName: 'AuthCodeSendIsEmpty',
      },
      {
        fieldToCheck: data?.timeout,
        errorName: 'AuthCodeTimeoutIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}

export function authCodeTokenGetHandler(data: AuthResult): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: data?.token,
        errorName: 'AuthCodeTokenGetIsEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
